import { Box, Button, Checkbox, Collapse, FormControlLabel, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { columnDefs, columnDefsForExcel, detailedTblData, dispatchMemoColDefs, dispatchMemoColDefs2, headerColDefs } from './Constants';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { useDispatch } from 'react-redux';
import Lineinput from '../../../common/lineinput';
import { getDispatchMemoData } from '../../../../store/reports/reports_action';
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment';
import { generateDynamicColumnStyles } from '../../../common/helper';
import FilterAltIcon from '@mui/icons-material/FilterAlt'

const FrnDetailedTbl = (props) => {
    const dispatch = useDispatch()
    const { selectedData, setSelectedData, tableData, setTableData, loginData, originalData, groupTables, 
        allownFormatLR, columns, Table1, convertToInt32
    } = props
    const [open, setOpen] = useState([]);
    const intCompanyID = loginData?.intCompanyID // Create a copy of the current table data
    const handleClickHeadOne = (index) => {
        setOpen((prev) => {
            if (prev.includes(index)) {
                return prev.filter((i) => i !== index); // Remove index if already open
            } else {
                return [...prev, index]; // Add index if not open
            }
        });
    };
   
    const [searchData, setSearchData] = useState({
        GeneratedDateTime: "",
        ChallanNo: "",
        BusNumber: "",
        BusCompanyName: "",
        PaidItems: "",
        TopayItems: "",
        totalItems: "",
        PaidAmt: '',
        ActualTopayAmt: '',
        TotalAmt: '',
        Charges: '',
        NetPayable: '',
        FromCity: '',
        FromBranch: '',
        ToCity: '',
        ToBranch: '',
        receiveValue: '',
        HasReceivedAtBranch: '',
        remarks: '',
        })
        useEffect(()=>{
            let updatedData = { ...searchData }; // Create a copy of the current state

            // Remove LRNO and formattedLRNO if they exist
            delete updatedData.LRNO;
            delete updatedData.formattedLRNO;
    
            if (allownFormatLR === 0) {
                updatedData.LRNO = "";
            } else if (allownFormatLR === 1) {
                updatedData.LRNO = "";
            } else if (allownFormatLR === 2) {
                updatedData.FormattedLRNO = ""; 
            } else if (allownFormatLR === 3) {
                updatedData.LRNO = "";
                updatedData.FormattedLRNO = ""; 
            }
    
            setSearchData(updatedData);
        },[allownFormatLR])
    const handleView = (row) => {
        let body = {
            intCompanyID: row?.CompanyID,
            intFromBranchID: row?.FromBranchID,
            intToBranchID: row?.ToBranchID,
            intChallanNo: row?.ChallanNo,
            dtDate: row?.GeneratedDateTime
        }
        dispatch(getDispatchMemoData(body)).then((res) => {
            if (res?.status === "Success") {
                generatepdf(res)
            }

        }).catch((err) => {
            console.log(err)
        })

    }
    const generatepdf = (res) => {
        let reportData1 = [...res?.Table]
        let reportData2 = [...res?.Table1]
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

        const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })

        doc.autoTableSetDefaults({
            headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
        })
        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(14)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left, pageHeight - 5, 'right')
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${loginData.strUserName} [ ${loginData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, doc.internal.pageSize.width / 2 -
                (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 + 90, pageHeight - 5
            )
        }
        doc.setProperties({
            title: `Dispatch Memo.pdf`,
            subject: 'Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Dispatch Memo',
            creator: 'MTLPL',
        })

        const remarksRow = { LRNoManualLRNO: 'Remarks:', FromCityBranch: '' }
        reportData1?.push(remarksRow)
        const totals = { PaymentType: 'Total', Quantity: 0, NetAmount: 0 };
        const signature = { PaymentType: 'Receiver Name: __________', Quantity: 'Date: __________', NetAmount: 'Sign: __________' }
        reportData2.forEach(item => {
            totals.Quantity += Number(item.Quantity) || 0; // Ensure to convert to number
            totals.NetAmount += Number(item.NetAmount) || 0; // Ensure to convert to number
        });

        reportData2?.push(totals)
        reportData2?.push(signature)

        autoTable(doc, {
            margin: { top: 230, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            startY: 230,
            columns: dispatchMemoColDefs,
            body: reportData1,
            columnStyles: generateDynamicColumnStyles(dispatchMemoColDefs, 14),
            // showHead: 'repeat',
            theme: 'grid',
            styles: {
                fontSize: 14,
                lineWidth: [0.6, 0.6, 0.6, 0.6]
            },
            tableLineWidth: 0.6,
            headStyles: {
                fontSize: 14,
                fillColor: [182, 222, 254],
                textColor: [0, 0, 0],
                cellPadding: 6,
                valign: 'middle',
                fontStyle: 'normal',
                font: 'Roboto',
            },
            didParseCell: (data) => {
                if (data.row.section === 'head' || data.row.section === 'body') {
                    if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                        data.cell.styles.halign = 'right'
                    } else {
                        data.cell.styles.halign = 'left'
                    }
                }
            },
            willDrawCell: (data) => {
                // Check if it's the last row and the second cell (index 1)
                if (data.row.index === data.table.body.length - 1 && data.column.index === 1) {
                    data.cell.colSpan = 8; // Set colspan to 6
                }
            },

        })

        autoTable(doc, {
            margin: { top: 215, left: 30, right: 600, bottom: 0 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            startY: doc.lastAutoTable.finalY + 24,
            columns: dispatchMemoColDefs2,
            body: reportData2,
            columnStyles: {
                0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', cellPadding: 8, fontStyle: 'normal', textColor: [0, 0, 0], },
                1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', cellPadding: 8, fontStyle: 'normal', textColor: [0, 0, 0], },
                2: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', cellPadding: 8, fontStyle: 'normal', textColor: [0, 0, 0], },
            },
            theme: 'grid',
            showHead: 'everyPage',
            headStyles: {
                halign: 'left',
                valign: 'middle',
                cellPadding: 12,
                fontSize: 14,
                minCellHeight: 36,
                fillColor: [182, 222, 254],
                textColor: [0, 0, 0],
                fontStyle: 'bold',
                font: 'Roboto',
                lineWidth: 0.6,
            },
            didParseCell: (data) => {
                if (data.row.section === 'head' || data.row.section === 'body') {
                    if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                        data.cell.styles.halign = 'right'
                    } else {
                        data.cell.styles.halign = 'left'
                    }
                }
            },
            willDrawCell: (data) => {
                if (data.row.raw.isSubHeading) {
                    doc.setFillColor(218, 237, 254);
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(12).setFont("Roboto", 'normal')
                    data.cell.styles.valign = 'middle';
                } else if (data.row.raw.isTotalRow) {
                    doc.setFillColor(238, 238, 238);
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(12).setFont("Roboto", 'normal')
                    data.cell.styles.valign = 'middle';
                }
            },
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(16)
                doc.setFont('Roboto', 'bold')
                doc.text(`Generated For: ${moment(new Date()).format('DD-MMM-YYYY')}`, 30, 145)
                doc.setFontSize(16)
                doc.setFont('Roboto', 'bold')
                doc.text(`Vehicle No: ${reportData1?.[0]?.VehicleNo}`, doc.internal.pageSize.width - data.settings.margin.left, 145, 'right')
                doc.setFontSize(16)
                doc.setFont('Roboto', 'bold')
                doc.text(`By Branch: ${reportData1?.[0]?.FromBranch}`, 30, 165)
                doc.setFontSize(16)
                doc.setFont('Roboto', 'bold')
                doc.text(`Generation Time: ${moment(new Date()).format('hh:mm A')}`, doc.internal.pageSize.width - data.settings.margin.left, 165, 'right')

                doc.setFontSize(16)
                doc.setFont('Roboto', 'bold')
                doc.text(`Dispatched ToCity: ${reportData1?.[0]?.DispatchedToCity}`, 30, 185)
                doc.setFontSize(16)
                doc.setFont('Roboto', 'bold')
                doc.text(`ChanllanNo: ${reportData1?.[0]?.VoucherNo}`, doc.internal.pageSize.width - data.settings.margin.left, 185, 'right')

                doc.setFontSize(16)
                doc.setFont('Roboto', 'bold')
                doc.text(`Dispatched ToBranch: ${reportData1?.[0]?.DispatchedToBranch}`, 30, 205)

                doc.setTextColor(40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
                doc.setFontSize(20).setFont('Roboto', 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System | Dispatch Memo', 30 + 60, 80)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(20).setFont('Roboto', 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
        })

        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        const pdfBlob = new Blob([doc.output('blob')], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        // Open the PDF in a new tab
        window.open(pdfUrl);
    }
    const getSharingPercentage = (companyID, VehicleCompanyID) => {
        const sharingEntry = Table1.find(
          (entry) => entry.SendingCompanyID === companyID && Number(entry.ReceivingCompanyID) === VehicleCompanyID
        );
        return sharingEntry ? sharingEntry.SharingPercentage : 0; // Default to 0 if not found
      };
    useEffect(() => {
            const filteredToPayData = originalData?.filter((val) => {
                return (
                    (searchData?.GeneratedDateTime === "" || (val?.GeneratedDateTime && val?.GeneratedDateTime?.toLocaleLowerCase().includes(searchData?.GeneratedDateTime?.toLocaleLowerCase()))) &&
                    (searchData?.ChallanNo === "" || (val?.ChallanNo && val?.ChallanNo?.toLocaleLowerCase().includes(searchData?.ChallanNo?.toLocaleLowerCase()))) &&
                    (searchData?.BusNumber === "" || (val?.BusNumber && val?.BusNumber?.toLocaleLowerCase().includes(searchData?.BusNumber?.toLocaleLowerCase()))) &&
                    (searchData?.BusCompanyName === "" || (val?.BusCompanyName && val?.BusCompanyName?.toLocaleLowerCase().includes(searchData?.BusCompanyName?.toLocaleLowerCase()))) &&
                    (searchData?.PaidItems === "" || (val?.PaidItems && val?.PaidItems?.toString().toLocaleLowerCase().includes(searchData?.PaidItems))) &&
                    (searchData?.TopayItems === "" || (val?.TopayItems && val?.TopayItems?.toString().toLocaleLowerCase().includes(searchData?.TopayItems))) &&
                    (searchData?.totalItems === "" || (val?.totalItems && val?.totalItems?.toString().toLocaleLowerCase().includes(searchData?.totalItems))) &&
                    (searchData?.PaidAmt === "" || (val?.PaidAmt && val?.PaidAmt?.toString().toLocaleLowerCase().includes(searchData?.PaidAmt))) &&
                    (searchData?.ActualTopayAmt === "" || (val?.ActualTopayAmt && val?.ActualTopayAmt?.toString().toLocaleLowerCase().includes(searchData?.ActualTopayAmt))) &&
                    (searchData?.TotalAmt === "" || (val?.TotalAmt && val?.TotalAmt?.toString().toLocaleLowerCase().includes(searchData?.TotalAmt))) &&
                    (searchData?.Charges === "" || (val?.Charges && val?.Charges?.toString().toLocaleLowerCase().includes(searchData?.Charges))) &&
                    (searchData?.NetPayable === "" || (val?.NetPayable && val?.NetPayable?.toString().toLocaleLowerCase().includes(searchData?.NetPayable))) &&
                    (searchData?.FromCity === "" || (val?.FromCity && val?.FromCity?.toLocaleLowerCase().includes(searchData?.FromCity?.toLocaleLowerCase()))) &&
                    (searchData?.FromBranch === "" || (val?.FromBranch && val?.FromBranch?.toLocaleLowerCase().includes(searchData?.FromBranch?.toLocaleLowerCase()))) &&
                    (searchData?.ToCity === "" || (val?.ToCity && val?.ToCity?.toLocaleLowerCase().includes(searchData?.ToCity?.toLocaleLowerCase()))) &&
                    (searchData?.ToBranch === "" || (val?.ToBranch && val?.ToBranch?.toLocaleLowerCase().includes(searchData?.ToBranch?.toLocaleLowerCase()))) &&
                    (searchData?.receiveValue === "" || (val?.receiveValue && val?.receiveValue?.toLocaleLowerCase().includes(searchData?.receiveValue?.toLocaleLowerCase()))) &&
                    (searchData?.HasReceivedAtBranch === "" || (val?.HasReceivedAtBranch && val?.HasReceivedAtBranch?.toLocaleLowerCase().includes(searchData?.HasReceivedAtBranch?.toLocaleLowerCase()))) &&
                    (searchData?.remarks === "" || (val?.remarks && val?.remarks?.toLocaleLowerCase().includes(searchData?.remarks?.toLocaleLowerCase()))) &&
                    (searchData?.LRNO === undefined || searchData?.LRNO === "" || (val?.LRNO && val?.LRNO?.toLocaleLowerCase().includes(searchData?.LRNO?.toLocaleLowerCase()))) &&
                    (searchData?.FormattedLRNO === undefined || searchData?.FormattedLRNO === "" || (val?.FormattedLRNO && val?.FormattedLRNO?.toLocaleLowerCase().includes(searchData?.formattedLRNO?.toLocaleLowerCase())))
                );
            });
    
            let newGroupData = groupTables(filteredToPayData);
            const newCombinedData = newGroupData?.map(group => {
                         const updatedToPayData = group.toPayData?.map(row => {
                           if (row.isTotalRow) return row; // We'll update this later
                           const VehicleCompanyID = row.VehicleCompanyID;
                           const CompanyID = row.CompanyID;
                           const DestinationCompanyID = row.DestinationCompanyID;
                           const TopayAmt = Number(row.TopayAmt) || 0;
                           const PaidAmt = Number(row.PaidAmt) || 0;
                           const ActualTopayAmt = Number(row.ActualTopayAmt) || 0;
                           const finalSharingCommPer = ((100 - getSharingPercentage(CompanyID, VehicleCompanyID)) / 100);
                           const totalAmt = PaidAmt + ActualTopayAmt;
                           let Charges = 0;
                           let NetPayable = 0;
                       
                           if (intCompanyID !== VehicleCompanyID && intCompanyID !== CompanyID && intCompanyID === DestinationCompanyID) {
                             Charges = Number(TopayAmt);
                             NetPayable = 0;
                           } else if (intCompanyID !== VehicleCompanyID && intCompanyID === CompanyID && intCompanyID !== DestinationCompanyID) {
                             NetPayable = ((PaidAmt + ActualTopayAmt) * finalSharingCommPer) - PaidAmt;
                             Charges = NetPayable < 0 ? Math.abs(NetPayable) : 0;
                           } else if (intCompanyID === VehicleCompanyID && intCompanyID !== CompanyID && intCompanyID !== DestinationCompanyID) {
                             Charges = Number((PaidAmt + ActualTopayAmt) * finalSharingCommPer).toFixed(1);
                             NetPayable = PaidAmt - Charges;
                           } else if (intCompanyID === VehicleCompanyID && intCompanyID !== CompanyID && intCompanyID === DestinationCompanyID) {
                             Charges = Number(totalAmt * finalSharingCommPer).toFixed(1);
                             NetPayable = PaidAmt - convertToInt32(Charges);// Math.round(Charges)
                           } else if (intCompanyID === VehicleCompanyID && intCompanyID === CompanyID && intCompanyID !== DestinationCompanyID) {
                             Charges = 0;
                             NetPayable = TopayAmt;
                           }
                        
                           return {
                             ...row,
                             GeneratedDateTime: row.GeneratedDateTime ? moment(row.GeneratedDateTime).format('DD-MMM-YYYY') : '',
                             totalItems: Number(row.PaidItems) + Number(row.TopayItems),
                             receiveValue: Number(row.IsReceived) === 1 ? 'Paid' : 'UnPaid',
                             receive: Number(row.IsReceived),
                             remarks: row.Remarks,
                             HasReceivedAtBranch: Number(row.HasReceivedAtBranch) === 1 ? 'Yes' : 'No',
                             IsReceived: Number(row.IsReceived),
                             Charges: Number(Charges),
                             NetPayable: Math.round(NetPayable),
                             totalAmt: Math.round(totalAmt),
                           };
                         });
                         // Sum up the totals for the new total row
                         const dataWithoutTotalRow = updatedToPayData.filter(row => !row.isTotalRow);
                       
                         let totalRow = {
                           isTotalRow: true,
                           GeneratedDateTime: 'Total',
                           PaidItems: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.PaidItems) || 0), 0),
                           TopayItems: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.TopayItems) || 0), 0),
                           totalItems: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.totalItems) || 0), 0),
                           PaidAmt: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.PaidAmt) || 0), 0),
                           ActualTopayAmt: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.ActualTopayAmt) || 0), 0),
                           ToPayComm: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.ToPayComm) || 0), 0),
                           totalAmt: Math.round(dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.totalAmt) || 0), 0)),
                           Charges:(dataWithoutTotalRow.reduce((acc, row) => Number(acc) + (Number(row.Charges) || 0), 0)).toFixed(1),
                           NetPayable: Math.round(dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.NetPayable) || 0), 0)),
                           // NetPayable:0
                         };
                         // totalRow.NetPayable=totalRow?.totalAmt- Math.round(totalRow?.Charges, 0)
           
                         return {
                           ...group,
                           toPayData: [...dataWithoutTotalRow, totalRow]
                         };
                       });
            setTableData(newCombinedData);
    }, [searchData]);
    const handleSearchData = (event, dataKey) => {
        const value = event.target.value.toString(); // Convert value to string
        setSearchData((prevState) => ({
            ...prevState,
            [dataKey]: value, // Update the specific key based on dataKey
        }));
    };
    return (
        <Box style={{ padding: '10px 22px 10px 22px' }}>

            <TableContainer className='scrollBlue' component={Paper} style={{ marginBottom: '5px', maxHeight: '45vh' }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                        <TableRow>
                            <TableCell key={`CityHeader-icon`} style={{
                                backgroundColor: '#DAEDFE',
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#444',
                                height: '36px',
                                whiteSpace: 'pre',
                                padding: '6px'
                            }}></TableCell>
                            {columns?.map((col, index) => (
                                <TableCell key={`CityHeader-${index}`} style={{
                                    ...col.headerSx,
                                    backgroundColor: '#DAEDFE',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#444',
                                    height: '36px',
                                    whiteSpace: 'pre',
                                    padding: '6px'
                                }}>
                                    {col.header}
                                </TableCell>
                            ))}
                        </TableRow>
                        <TableRow>
                        <TableCell key={`FTH-icon`} style={{ height: "36px" }}> </TableCell>
                            {columns?.map((col, index) => (
                                <TableCell key={`FTH-${index}`} style={{ height: "36px", padding :'0px 0px' }}>
                                    { (index !== columns?.length - 1 && index !== columns?.length - 3 && index !== columns?.length - 4) && <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between', padding:'4px 4px' }}>
                                        <input
                                            id={`Contains-${index}`}
                                            className="field"
                                            name="cancelSearchInput"
                                            style={{ width: '100%', height: "24px" }}
                                            placeholder="Contains"
                                            autoComplete="off"
                                            value={searchData[col.dataKey]}
                                            onChange={(e) =>handleSearchData(e, col.dataKey)}
                                        />
                                        <FilterAltIcon style={{ color: "#aaa" }} />
                                    </div>}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    {tableData?.length > 0 ?
                        <TableBody>
                            {tableData?.map((val, index) => (
                                <React.Fragment key={index}>
                                    <TableRow>
                                        <TableCell style={{ width: '2%' }}>
                                            <IconButton
                                                aria-label="expand row"
                                                size="small"
                                                onClick={() => handleClickHeadOne(index)} // Use the handleClick function
                                            >
                                                {open.includes(index) ? <RemoveCircleIcon sx={{ color: '#2F89EB' }} /> : <AddCircleIcon />}
                                            </IconButton>
                                        </TableCell>
                                        <TableCell colSpan={columns?.length} style={{ height: '40px', fontSize: '13px', fontWeight: '600', color: '#444', padding: '6px', width: '98%' }}>{val.GeneratedDateTime}</TableCell>
                                    </TableRow>
                                    {val?.toPayData && open.includes(index) && (
                                        val.toPayData.map((rowTwo, indexTwo) => (
                                            rowTwo?.isTotalRow ?
                                                <TableRow key={indexTwo}>
                                                    <TableCell style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '2%' }}></TableCell>
                                                    <TableCell colSpan={allownFormatLR===3?6:5} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', minWidth: '100px',textAlign:'right' }}>{rowTwo.GeneratedDateTime}</TableCell>
                                                    <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.PaidItems}</TableCell>
                                                    <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.TopayItems}</TableCell>
                                                    <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.totalItems}</TableCell>
                                                    <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.PaidAmt}</TableCell>
                                                    <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.ActualTopayAmt}</TableCell>
                                                    <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.totalAmt}</TableCell>
                                                    <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.Charges}</TableCell>
                                                    <TableCell colSpan={1} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.NetPayable}</TableCell>
                                                    <TableCell colSpan={10} style={{ height: '40px', background: '#EEEEEE', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}></TableCell>
                                                </TableRow> :
                                                <TableRow key={indexTwo}>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '2%' }}></TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', minWidth: '100px' }}>{rowTwo.GeneratedDateTime}</TableCell>
                                                    {(allownFormatLR===0||allownFormatLR===1||allownFormatLR===3) && <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.LRNO}</TableCell>}
                                                    {(allownFormatLR===2||allownFormatLR===3) && <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.FormattedLRNO}</TableCell>}
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.ChallanNo}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', minWidth: '130px' }}>{rowTwo.BusNumber}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.BusCompanyName}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.PaidItems}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.TopayItems}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.totalItems}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.PaidAmt}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.ActualTopayAmt}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.totalAmt}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.Charges}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'right' }}>{rowTwo.NetPayable}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', minWidth: '150px', textAlign: 'left' }}>{rowTwo.FromCity}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', minWidth: '200px', textAlign: 'left' }}>{rowTwo.FromBranch}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', minWidth: '150px', textAlign: 'left' }}>{rowTwo.ToCity}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', minWidth: '200px', textAlign: 'left' }}>{rowTwo.ToBranch}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%' }}>{rowTwo.receiveValue}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', minWidth: '10%', textAlign: 'center' }}>
                                                        <FormControlLabel
                                                            value="end"
                                                            control={
                                                                <Checkbox
                                                                    id={`chkbox-${index}-${indexTwo}`} // Unique ID for each checkbox
                                                                    checked={rowTwo.receive === 1} // Check the current value
                                                                    onChange={(e) => {
                                                                        let newData = [...tableData];
                                                                        let condition = ((rowTwo.receiveValue == "Paid" || rowTwo.VehicleCompanyID != intCompanyID || rowTwo.HasReceivedAtBranch == 0) || (rowTwo.CompanyID == rowTwo.VehicleCompanyID && rowTwo.CompanyID == intCompanyID))
                                                                        if (!condition) {
                                                                            newData[index].toPayData[indexTwo].receive = e.target.checked ? 1 : 0
                                                                            if (e.target.checked) {
                                                                                selectedData.push(rowTwo);
                                                                            } else {
                                                                                newData[index].toPayData[indexTwo].remarks =  newData[index].toPayData[indexTwo].Remarks!==''?newData[index].toPayData[indexTwo].Remarks:''
                                                                                const rowIndex = selectedData.findIndex(item => item.BookingID === rowTwo.BookingID); // Assuming each row has a unique 'id'
                                                                                if (rowIndex !== -1) {
                                                                                    selectedData.splice(rowIndex, 1); // Remove the row from selectedData
                                                                                }
                                                                            }
                                                                        }
                                                                        setTableData(newData); // Update the state with the new data
                                                                    }}
                                                                    sx={{ fontSize: '12px', padding: '0px', backgroundColor: 'transparent !important' }}
                                                                // disabled={((rowTwo.receiveValue == "Paid" ||rowTwo.VehicleCompanyID != intCompanyID || rowTwo.HasReceivedAtBranch == 0) || (rowTwo.CompanyID == rowTwo.VehicleCompanyID && rowTwo.CompanyID == intCompanyID))} // Disable if already received
                                                                />
                                                            }
                                                            labelPlacement="end"
                                                        />
                                                    </TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'center' }}>
                                                        <Button
                                                            variant="contained"
                                                            // onKeyDown={(e) => navigation3(e, 'printBtn', 'gv-partyName', () => { })}
                                                            id={'load_Btn'}
                                                            sx={{ width: '60%', padding: '0px 0px !important', fontSize: '14px !important' }}
                                                            className="btn btn-primary"
                                                            onClick={() => {
                                                                handleView(rowTwo)
                                                            }
                                                            }
                                                        > View
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '10%', textAlign: 'left' }}>{rowTwo.HasReceivedAtBranch}</TableCell>
                                                    <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', minWidth: '200px' }}>{(rowTwo?.receive === 1) ?
                                                         <div
                                                         className={'input--wrapper'}
                                                         style={{
                                                             width: '100%',
                                                             margin:'0px', 
                                                         }}>
                                                        <Lineinput
                                                            id=''
                                                            value={rowTwo.remarks}
                                                            onChange={(e) => {
                                                                let newData = [...tableData]; // Create a copy of the current table data
                                                                newData[index].toPayData[indexTwo].remarks = e.target.value; // Update the isRecValue based on checkbox state
                                                                setTableData(newData);
                                                            }}
                                                            // disabled
                                                        /></div> :
                                                        rowTwo.remarks}</TableCell>
                                                </TableRow>
                                        ))
                                    )}
                                </React.Fragment>
                            ))}
                        </TableBody> :
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={columns?.length + 1}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginTop: '20px',
                                            marginBottom: '20px',
                                            color: 'red',
                                            fontSize: '14px',
                                        }}
                                    >
                                        <span>No Results Found For The Selected Filters.</span>
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    }
                </Table>
            </TableContainer >
        </Box>
    )
}

export default FrnDetailedTbl
